import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import swal from 'sweetalert';

import Client from './Client';
import Config from './ClientConfig';
import active_on from './../images/icons/active_on.png';
import active_off from './../images/icons/active_off.png';

export default class Message extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: new Client('none'),
      item: {
        iref: '',
        createdOn: '',            // kept in state, but no longer displayed
        isActive: true,
        dateFrom: '',
        dateTo: '',
        sendToHQ: false,
        sendToAllLocationsOwn: false,
        sendToAllLocationsF: false,
        sendToAllClients: false,
        subject: '',
        message: '',
      },
      // read-only by default; auto-edit only for new items
      edit: props.isNew === true,
      allowEdit: props.allowEdit !== false,
      somethingHasChanged: false,
      isSaving: false,
      justSaved: false,
    };

    this.handleEditClick = this.handleEditClick.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.pushData = this.pushData.bind(this);

    this.toPayloadDate = this.toPayloadDate.bind(this);
    this.toYMD = this.toYMD.bind(this);
    this.toDMY = this.toDMY.bind(this);
  }

  componentDidMount() {
    if (this.props.item) {
      const incoming = { ...this.props.item };
      this.setState({ item: incoming });
    }
  }

  componentDidUpdate(prevProps) {
    // Only replace local state when a different item arrives (prevents wiping edits)
    if (this.props.item && (prevProps.item?.iref !== this.props.item.iref)) {
      const incoming = { ...this.props.item };
      this.setState({ item: incoming, edit: this.props.isNew === true });
    }
  }

  // ---------- date helpers (robust against T/timezones) ----------
  toPayloadDate(raw) {
    if (!raw) return null;
    const s = String(raw).trim();

    // YYYY-MM-DD or YYYY-MM-DD[ T]HH:mm[:ss][.sss][Z]
    let m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(s);
    if (m) return `${m[1]}-${m[2]}-${m[3]} ${m[4] || '00'}:${m[5] || '00'}:${m[6] || '00'}`;

    // DD-MM-YYYY or DD-MM-YYYY[ T]HH:mm[:ss]
    m = /^(\d{2})-(\d{2})-(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(s);
    if (m) return `${m[3]}-${m[2]}-${m[1]} ${m[4] || '00'}:${m[5] || '00'}:${m[6] || '00'}`;

    return null;
  }
  toYMD(value) {
    if (!value) return '';
    const s = String(value).trim();

    let m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s); // handles YYYY-MM-DD, YYYY-MM-DDTHH:mm:ss
    if (m) return `${m[1]}-${m[2]}-${m[3]}`;

    m = /^(\d{2})-(\d{2})-(\d{4})/.exec(s); // handles DD-MM-YYYY
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;

    return '';
  }
  toDMY(value) {
    if (!value) return '';
    const s = String(value).trim();

    let m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s); // YYYY-MM-DD -> DD-MM-YYYY
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;

    m = /^(\d{2})-(\d{2})-(\d{4})/.exec(s); // already DMY
    if (m) return `${m[1]}-${m[2]}-${m[3]}`;

    return '';
  }

  hasValidDates = () => {
    const { dateFrom, dateTo } = this.state.item || {};
    if (!dateFrom || !dateTo) return false;
    const d1 = this.toPayloadDate(dateFrom);
    const d2 = this.toPayloadDate(dateTo);
    if (!d1 || !d2) return false;
    return new Date(d1) <= new Date(d2);
  };

  handleEditClick(){
    if (!this.state.allowEdit) return;
    this.setState(prev => ({ edit: !prev.edit }));
  }

  changeValue(e){
    const id = e.target.id;
    const value = (e.target.type === 'checkbox') ? e.target.checked : e.target.value;
    this.setState(s => ({ item:{...s.item, [id]: value}, somethingHasChanged:true }));
  }

  // ---------- save ----------
  pushData() {
    if (!(this.state.edit && this.state.somethingHasChanged)) { swal('Error', 'Nothing to save', 'error'); return; }
    if (!this.hasValidDates()) { swal('Missing or invalid period', 'Please select both From and To dates (From must be before To).', 'warning'); return; }

    this.setState({ isSaving: true });
    try {
      const src = this.state.item;
      const payload = {
        ...(src.iref ? { iref: src.iref } : {}),
        isActive: !!src.isActive,
        dateFrom: this.toPayloadDate(src.dateFrom),
        dateTo:   this.toPayloadDate(src.dateTo),
        sendToHQ: !!src.sendToHQ,
        sendToAllLocationsOwn: !!src.sendToAllLocationsOwn,
        sendToAllLocationsF:   !!src.sendToAllLocationsF,
        sendToAllClients:      !!src.sendToAllClients,
        subject: (src.subject || '').trim(),
        message: (src.message || '').trim(),
      };

      const base = Config.API_URL_MESSAGE;
      const r = this.state.client.pushData(base, payload);

      if (r && (r.iref || r.updateKey)) {
        const next = { ...this.state.item, ...r };
        this.setState({ item: next, somethingHasChanged: false, isSaving: false, edit: false, justSaved: true });
        setTimeout(()=>this.setState({ justSaved: false }), 800);
        swal('Saved', 'Message saved successfully.', 'success', { buttons: false, timer: 1200 });
        if (typeof this.props.onUpdated === 'function') this.props.onUpdated();
        return;
      }
      const msg = (r && (r.message || (r.errors && JSON.stringify(r.errors)))) || 'Unknown error';
      swal('Save failed', msg, 'error'); this.setState({ isSaving: false });
    } catch (e) {
      const msg = (e && e.message) ? e.message : String(e);
      swal('Save failed', msg, 'error'); this.setState({ isSaving: false });
    }
  }

  // ---------- render ----------
  render() {
    const p = this.state.item || {};
    const activeAvatar = p.isActive ? active_on : active_off; 
    const activeAlt = p.isActive ? 'Active' : 'Inactive';

    // Inline header: Subject + isActive in one row, smaller controls
    const headerTitle = this.state.edit ? (
      <Box sx={{ display:'grid', gridTemplateColumns:'1fr auto', alignItems:'center', gap: 1 }}>
        <TextField
          id="subject"
          placeholder="Subject"
          value={p.subject || ''}
          onChange={this.changeValue}
          variant="outlined"
          size="small"
          inputProps={{ maxLength: 128 }}
          fullWidth
        />
        <FormControlLabel
          sx={{ m: 0 }}
          control={
            <Switch
              id="isActive"
              checked={!!p.isActive}
              onChange={(e)=>this.changeValue({target:{id:'isActive', type:'checkbox', checked:e.target.checked}})}
            />
          }
          label="Active"
        />
      </Box>
    ) : (
      <Box sx={{ display:'flex', alignItems:'center', gap: 1 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
          {p.subject || 'New Message'}
        </Typography>
        {/* <Typography
          variant="caption"
          sx={{
            px: 0.75, py: 0.25, borderRadius: 1,
            bgcolor: p.isActive ? 'success.light' : 'grey.200',
            color: p.isActive ? 'success.dark' : 'text.secondary'
          }}
        >
          {p.isActive ? 'Active' : 'Inactive'}
        </Typography> */}
      </Box>
    );

    const audienceControls = (
      <FormGroup sx={{ display:'grid', gridTemplateColumns:'repeat(2, minmax(140px, 1fr))', gap: 0 }}>
        {[
          // ['sendToHQ', 'HQ'],
          ['sendToAllLocationsOwn', 'Locations'],
          // ['sendToAllLocationsF', 'Franchise'],
          ['sendToAllClients', 'Clients'],
        ].map(([id, label]) => (
          <FormControlLabel
            key={id}
            sx={{ m: 0 }}
            control={
              <Checkbox
                id={id}
                checked={!!p[id]}
                onChange={(e)=>this.changeValue({target:{id, type:'checkbox', checked:e.target.checked}})}
              />
            }
            label={label}
          />
        ))}
      </FormGroup>
    );

    // Edit view (compact)
    const detailsEdit = (
      <Box sx={{ display:'grid', gridTemplateColumns:'minmax(280px, 1fr) 360px', gap: 1.5, alignItems:'start' }}>
        {/* Left: Message (smaller) */}
        <TextField
          id="message"
          label="Message"
          value={p.message || ''}
          onChange={this.changeValue}
          variant="outlined"
          size="small"
          multiline
          minRows={3}
          maxRows={10}
          inputProps={{ maxLength: 1024 }}
        />

        {/* Right: Period + Audience */}
        <Box sx={{ display:'grid', gap: 1 }}>
          <Box sx={{ p: 1, border:'1px solid #eee', borderRadius: 1 }}>
            {/* <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display:'block' }}>Period</Typography> */}
            <Box sx={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap: 1 }}>
              <TextField
                id="dateFrom_ui"
                label="From"
                type="date"
                variant="outlined"
                size="small"
                value={this.toYMD(p.dateFrom)}
                onChange={(e)=>this.setState(s=>({ item:{...s.item, dateFrom: this.toDMY(e.target.value)}, somethingHasChanged:true }))}
                InputLabelProps={{ shrink: true }}
                error={!p.dateFrom}
                helperText={!p.dateFrom ? 'Required' : ''}
              />
              <TextField
                id="dateTo_ui"
                label="To"
                type="date"
                variant="outlined"
                size="small"
                value={this.toYMD(p.dateTo)}
                onChange={(e)=>this.setState(s=>({ item:{...s.item, dateTo: this.toDMY(e.target.value)}, somethingHasChanged:true }))}
                InputLabelProps={{ shrink: true }}
                error={!p.dateTo}
                helperText={!p.dateTo ? 'Required' : ''}
              />
            </Box>
          </Box>

          <Box sx={{ p: 1, border:'1px solid #eee', borderRadius: 1 }}>
            {/* <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display:'block' }}>Audience</Typography> */}
            {audienceControls}
          </Box>
        </Box>
      </Box>
    );

    // Read-only view (compact)
    const detailsReadOnly = (
      <Box sx={{ display:'grid', gridTemplateColumns:'minmax(280px, 1fr) 360px', gap: 1.5, alignItems:'start' }}>
        {/* Left: Message */}
        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace:'pre-wrap' }}>
          {p.message || '—'}
        </Typography>

        {/* Right: Period + Audience */}
        <Box sx={{ display:'grid', gap: 1 }}>
          <Box sx={{ p: 1, border:'1px solid #eee', borderRadius: 1 }}>
            {/* <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display:'block' }}>Period</Typography> */}
            <Typography variant="body2" color="text.secondary">
              From: {p.dateFrom || '—'} &nbsp;•&nbsp; To: {p.dateTo || '—'}
            </Typography>
          </Box>

          <Box sx={{ p: 1, border:'1px solid #eee', borderRadius: 1 }}>
            {/* <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display:'block' }}>Audience</Typography> */}
            <Typography variant="body2" color="text.secondary">
              {/* HQ: {p.sendToHQ ? 'Yes' : 'No'} • Locations: {p.sendToAllLocationsOwn ? 'Yes' : 'No'} • Franchise: {p.sendToAllLocationsF ? 'Yes' : 'No'} • Clients: {p.sendToAllClients ? 'Yes' : 'No'} */}
              Locations: {p.sendToAllLocationsOwn ? 'Yes' : 'No'} • Clients: {p.sendToAllClients ? 'Yes' : 'No'}
            </Typography>
          </Box>
        </Box>
      </Box>
    );

    const saveEnabled = (this.state.edit && this.state.somethingHasChanged && this.hasValidDates() && !this.state.isSaving);

    return (
      <Card sx={{ borderRadius: '14px', m: 1, border: this.state.justSaved ? '2px solid #4caf50' : '1px solid #e0e0e0', transition: 'border 0.3s ease' }}>
        <CardHeader
          // avatar={<Avatar alt={activeAlt} src={activeAvatar} title={activeAlt} />}
          avatar={          
            <Box sx={{ display: 'flex', flexDirection: 'row', width: "100%" }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', width: "100%" }}>      
                <Avatar alt={activeAlt} src={activeAvatar} title={activeAlt}>
                </Avatar>  
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
                {p.iref ? (
                  <Typography variant="subtitle1" color="text.secondary">
                    {p.iref}
                  </Typography>
                ) : null}
              </Box>
            </Box> 
          }
          title={headerTitle}
          // createdOn removed from UI
          titleTypographyProps={{ component: 'div' }}
          sx={{ pb: 0, pt: 1 }}
          action={
            <Box sx={{ display:'flex', alignItems:'center', gap: 1 }}>
              {this.state.edit && (
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<SaveIcon />}
                  disabled={!saveEnabled}
                  onClick={this.pushData}
                  sx={{ ml: 2, minWidth: 84 }}
                >
                  {this.state.isSaving ? 'Saving…' : 'Save'}
                </Button>
              )}
              <IconButton aria-label="edit" onClick={this.handleEditClick}>
                <EditIcon sx={{ color: this.state.edit ? '#8f241d' : '#9aa0a6' }} />
              </IconButton>
            </Box>
          }
        />

        <Divider />

        {/* Always visible content (no collapsed layout) */}
        <CardContent sx={{ pt: 1.25, pb: 1.25 }}>
          {this.state.edit ? detailsEdit : detailsReadOnly}
        </CardContent>

        {/* Minimal footer to keep spacing consistent */}
        <CardActions sx={{ justifyContent: 'flex-end', pt: 0, pb: 1, pr: 1.5 }}>
          <Typography variant="caption" color="text.secondary">
            {this.state.edit ? (this.state.somethingHasChanged ? 'Unsaved changes' : '') : ''}
          </Typography>
        </CardActions>
      </Card>
    );
  }
}
